import React, { Component } from 'react';
import {
  Button,
  Typography,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  DialogActions,
} from '@material-ui/core';
import MaterialTable from 'material-table';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Delete from '@material-ui/icons/Delete';
import AssignmentReturnedIcon from '@material-ui/icons/AssignmentReturned';
import CloseIcon from '@material-ui/icons/Close';
import { cloneDeep } from 'lodash';
import i18n from '../../i18n';
import '../../assets/stylesheets/Closet.css';
import {
  imageThumbnail,
  closetImageThumbnailHeight,
} from '../../constants/general';
import { tableIcons } from '../shared/icons';
import GenericConfirmActionModal from '../GenericConfirmActionModal';
import RequireFeatureFlag from '../RequireFeatureFlag';
import { cartToText } from '../../helpers/cartToText';

import closetCartSlice, { hydrateItems as hydrateItemsThunk } from '../../collections/closetCart';

class CartModal extends Component {

  constructor(props) {
    super(props);

    this.state = {
      confirmation: null
    }
  }

  componentDidMount() {
    const { cart, hydrateItems } = this.props;
    if (cart.hydrated === false) {
      hydrateItems();
    }
  }

  clearCart = () => {
    const { onClose, clearCart } = this.props;
    this.confirm(i18n.t('closet:clearCartConfirm')).then(() => {
      onClose();
      clearCart();
    }).catch()
  }

  confirm = (msg) => {
    const promise = new Promise((resolve, reject) => {
      this.setState({
        confirmation: {
          msg,
          onClose: () => {
            // eslint-disable-next-line prefer-promise-reject-errors
            reject('User Cancelled the confirmation modal')
          },
          onConfirm: resolve
        }
      });
    });
    return promise.finally(() => {
      this.setState({ confirmation: null });
    });

  }

  copyToClipboard = data => {
    const { openSnackbar } = this.props;

    navigator.clipboard.writeText(cartToText(data)).then(() => {
      openSnackbar(i18n.t('closet:clipboardCopySuccess'));
    }, () => {
      openSnackbar(i18n.t('closet:clipboardCopyFailure'));
    });
  }

  requestItems = () => {
    const { openRequestModal } = this.props;
    openRequestModal()
  }

  render() {
    const { confirmation } = this.state;
    const { cart, showModal, onClose, removeItems } = this.props;

    const columns = [
      {
        title: i18n.t('closet:previewColumn'), field: 'product.images[0].image',
        render: rowData => rowData.product ? <img
          src={rowData.product.images[0]?.image?.replace('__IMAGE_PARAMS__', imageThumbnail)}
          alt={rowData.product.name}
          height={closetImageThumbnailHeight}
        /> : ''
      },
      { title: i18n.t('closet:productNameColumn'), field: 'product.name' },
      { title: i18n.t('closet:productCode'), field: 'product.sku' },
      { title: i18n.t('closet:sizeColumn'), field: 'size.name' },
      { title: i18n.t('closet:qtyColumn'), field: 'qty' }
    ];

    const actions = [
      {
        tooltip: <Typography>{i18n.t('closet:removeCartItem')}</Typography>,
        icon: Delete,
        onClick: (e, data) => { removeItems(data) }
      },
      {
        tooltip: <Typography>{i18n.t('closet:copyToClipboard')}</Typography>,
        icon: AssignmentReturnedIcon,
        onClick: (e, data) => { this.copyToClipboard(data) }
      }
    ]

    return (
      <Dialog
        open={showModal}
        onClose={onClose}
        scroll='paper'
        className='cartModal'
      >
        <IconButton className="closeDialogIcon" aria-label="close" onClick={onClose}>
          <CloseIcon />
        </IconButton>
        <DialogTitle>
          {i18n.t('closet:yourCart')}
        </DialogTitle>
        <DialogContent>
          {
            cart.items.length === 0 ?
              <Typography>
                {i18n.t('closet:emptyCart')}
              </Typography>
              :
              <MaterialTable columns={columns} data={cloneDeep(cart.items)} title="" options={{ selection: true }} actions={actions} icons={tableIcons} />
          }
        </DialogContent>
        <DialogActions>
          <RequireFeatureFlag feature="isClosetRequestEnabled">
            {cart.items.length !== 0 ?
              <Button
                onClick={this.requestItems}
                className="ssenseButton ssensePrimary"
              >
                {i18n.t('closet:requestItems')}
              </Button>
              : ''}
          </RequireFeatureFlag>
          <Button
            onClick={this.clearCart}
            className="ssenseButton ssenseWarning"
          >
            {i18n.t('closet:clearCart')}
          </Button>
          <Button
            onClick={onClose}
            className="ssenseButton ssenseDefault"
          >
            {i18n.t('close')}
          </Button>
        </DialogActions>
        {confirmation && (
          <GenericConfirmActionModal
            showModal={confirmation != null}
            onClose={confirmation.onClose}
            confirmMessage={confirmation.msg}
            onConfirm={confirmation.onConfirm}
          />
        )}
      </Dialog>
    );
  }
}

const mapDispatchToProps = {
  removeItems: closetCartSlice.actions.removeItems,
  clearCart: closetCartSlice.actions.clear,
  hydrateItems: hydrateItemsThunk
};

const mapStateToProps = state => ({
  cart: state.closetCart,
});

CartModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  openRequestModal: PropTypes.func.isRequired,
  openSnackbar: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  clearCart: PropTypes.func.isRequired,
  removeItems: PropTypes.func.isRequired,
  hydrateItems: PropTypes.func.isRequired,
  cart: PropTypes.shape({
    hydrated: PropTypes.bool,
    items: PropTypes.array,
  }).isRequired,
}

export { CartModal as CartModalNoConnect }
export default connect(mapStateToProps, mapDispatchToProps)(CartModal);